module.exports = __webpack_public_path__ + "static/img/dragonVRMonitor.58f51df7.png";